//src/hooks/useAnalytics.js
import { useEffect } from "react";
import { useLocation } from "react-router-dom";

export default function useAnalytics() {
  const location = useLocation();

  useEffect(() => {
    if (window.gtag) {
      window.gtag("config", "G-EVS61G3J9R", {
        page_path: location.pathname,
      });
    }
  }, [location]);
}